$(document).ready(function() {
  const urlParams = new URLSearchParams(window.location.search);
  const tab = urlParams.get('tab');
  if (tab) {
    const tabElement = $(`[data-bs-target="#nav-tab-${tab}"]`);
    if (tabElement.length) {
      tabElement.click();
    }
  }
});